import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductCharacteristics',
  props: {
    reference: {
      type: String,
      default: null
    },
    parameters: {
      type: Object,
      default: null
    },
    zod: {
      type: Array,
      default: null
    },
    documents: {
      type: Array,
      default: null
    },
    isAlone: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    handleClick: function handleClick(evt, arg) {
      var result = {
        COVER: 'dimensions',
        TECHNICAL: 'document_technique',
        ASSEMBLY: 'telecharger_notice_montage'
      };
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: 'FicheProduit',
          event_action: "Clic_".concat(result[arg.type]),
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }
  }
};